import { render, staticRenderFns } from "./PruebaTonosCard.vue?vue&type=template&id=1fc404e0&scoped=true&"
import script from "./PruebaTonosCard.vue?vue&type=script&lang=js&"
export * from "./PruebaTonosCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc404e0",
  null
  
)

export default component.exports